import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { CustomersService } from '../../core/services/CustomersService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { ICustomerCard } from '../../core/interfaces/ICustomerCard';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { CartService } from '../../../cart/core/services/CartService';

@Component({
  selector: 'app-cards-table',
  standalone: true,
  imports: [
    TranslatePipe,
    LoaderComponent,
    EmptyPipe
  ],
  templateUrl: './cards-table.component.html',
  styleUrl: './cards-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardsTableComponent extends BaseComponent implements OnInit {

  @Input({ required: true }) customer: ICustomer;

  private readonly _customersService = inject(CustomersService);
  private readonly _cartService = inject(CartService);

  public isLoading = signal(true);
  private readonly attachingCardNumber = signal<string | null>(null);
  public data: ICustomerCard[] = [];

  public readonly hasActiveBasket = computed(
    () => !!this.terminalsStore.selectedTerminal()?.currentSession?.currentBasketId
  );

  public readonly isUseCardDisabled = computed(
    () => !this.hasActiveBasket() || !!this.attachingCardNumber()
  );

  public ngOnInit(): void {
    this._customersService.getCustomerCards(this.customer)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: (data) => this.data = data.data,
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`get-customer-cards/notifications/${error.message}.Message`)
          );
        }
      });
  }

  public useCard(card: ICustomerCard): void {
    if (this.isUseCardDisabled()) {
      return;
    }

    this.attachingCardNumber.set(card.cardNumber);

    this._cartService.attachCardToCart(card.cardNumber)
      .pipe(
        finalize(() => this.attachingCardNumber.set(null))
      )
      .subscribe({
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`attach-card/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
